import React, { useEffect } from 'react'

const Ad = props => {
    const { currentPath } = props
    useEffect(() => {
        try {
            window.adsbygoogle = window.adsbygoogle || []
            window.adsbygoogle.push({})
        } catch (error) {
            console.log(error)

        }

    }, [currentPath])
    return (
        <div key={currentPath}>
            {/* <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-6401374113536219"
                data-ad-slot="6777430211"
                data-ad-format="auto"
                data-full-width-responsive="true" /> */}
            {/* <amp-ad width="100vw" height="320"
                type="adsense"
                data-ad-client="ca-pub-9306296395602524"
                data-ad-slot="4309003375"
                data-auto-format="rspv"
                data-full-width="">
                <div overflow=""></div>
            </amp-ad> */}
            <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-9306296395602524"
                data-ad-slot="4309003375"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
        </div>
    )
}

export default Ad
